/**
 * Forthbridge Clinical Document
 * Forthbridge Clinical Document API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateRelationshipRequestDto { 
    /**
     * Target entity identifier
     */
    targetId: string;
    /**
     * Target entity type
     */
    targetEntity: string;
    /**
     * Type of relationship
     */
    type: CreateRelationshipRequestDto.TypeEnum;
    /**
     * Order of the relationship
     */
    order: number;
}
export namespace CreateRelationshipRequestDto {
    export type TypeEnum = 'relatedTo' | 'blocks' | 'blockedBy' | 'duplicates' | 'partOf' | 'basedOn';
    export const TypeEnum = {
        RelatedTo: 'relatedTo' as TypeEnum,
        Blocks: 'blocks' as TypeEnum,
        BlockedBy: 'blockedBy' as TypeEnum,
        Duplicates: 'duplicates' as TypeEnum,
        PartOf: 'partOf' as TypeEnum,
        BasedOn: 'basedOn' as TypeEnum
    };
}


